import Image from "next/image";
import Link from "next/link";

import styles from "@styles/checkout/empty.module.scss";
const CheckOutEmpty = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 col-lg-4"></div>
        <div className="col-md-12 col-lg-4">
          <div className={styles.checkoutLogged}>
            <div className={styles.bagEmptyBlock}>
              <span className={styles.bagEmpty}>
                <Image
                  width="40"
                  height="50"
                  src="/assets/images/bag-empty.svg"
                  alt="bag-empty"
                />
              </span>
              <p>Your bag is empty</p>
              <Link href="/" className={styles.btnCustom}>
                Shop now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckOutEmpty;
